/* eslint-disable @atlassian/perf-linting/no-quadratic-complexity -- bounded traversal of Relay artifact argument values */
import { type ReaderArgument, type ReaderLinkedField, type ReaderScalarField } from 'relay-runtime';

function isObjectRecord(value: unknown): value is Record<string, unknown> {
	return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

function stableCopy(value: unknown): unknown {
	if (Array.isArray(value)) {
		return value.map(stableCopy);
	}

	if (isObjectRecord(value)) {
		const result: Record<string, unknown> = {};
		for (const key of Object.keys(value).sort()) {
			const fieldValue = value[key];
			if (fieldValue !== undefined) {
				result[key] = stableCopy(fieldValue);
			}
		}

		return result;
	}

	return value;
}

function formatStorageValue(value: unknown): string {
	return JSON.stringify(stableCopy(value));
}

export function formatRelayStorageArgs(args: Record<string, unknown>): string {
	const formattedArgs: string[] = [];
	for (const argName of Object.keys(args).sort()) {
		const value = args[argName];
		if (value != null) {
			formattedArgs.push(`${argName}:${formatStorageValue(value)}`);
		}
	}

	return formattedArgs.length === 0 ? '' : `(${formattedArgs.join(',')})`;
}

function resolveRelayArgValue(arg: ReaderArgument, variables: Record<string, unknown>): unknown {
	switch (arg.kind) {
		case 'Literal':
			return arg.value;
		case 'Variable':
			return variables[arg.variableName];
		case 'ListValue':
			return arg.items.map((item) => (item ? resolveRelayArgValue(item, variables) : null));
		case 'ObjectValue': {
			const value: Record<string, unknown> = {};
			for (const field of arg.fields) {
				value[field.name] = resolveRelayArgValue(field, variables);
			}

			return value;
		}
	}
}

export function getRelayFieldStorageKey(
	field: ReaderLinkedField | ReaderScalarField,
	variables: Record<string, unknown> = {},
): string {
	if (field.storageKey) {
		return field.storageKey;
	}

	if (!field.args || field.args.length === 0) {
		return field.name;
	}

	const formattedArgs: Record<string, unknown> = {};
	for (const arg of field.args.slice().sort((a, b) => a.name.localeCompare(b.name))) {
		const value = resolveRelayArgValue(arg, variables);
		if (value != null) {
			formattedArgs[arg.name] = value;
		}
	}

	return `${field.name}${formatRelayStorageArgs(formattedArgs)}`;
}
